export const NO_HYDRATION = 'noHydration';
export const MOCK_ENABLED = 'mockEnabled';
